import { render, staticRenderFns } from "./3_m_inquiryFranchise.vue?vue&type=template&id=cf9389cc&scoped=true&"
import script from "./3_m_inquiryFranchise.vue?vue&type=script&lang=js&"
export * from "./3_m_inquiryFranchise.vue?vue&type=script&lang=js&"
import style0 from "./3_m_inquiryFranchise.vue?vue&type=style&index=0&id=cf9389cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf9389cc",
  null
  
)

export default component.exports